import React from 'react';
import { Check, Edit2, Loader, X } from 'react-feather';

import { useCategories } from './hooks/useCategories';

const CategoriesListPage: React.FC = () => {
  const { states, handlers } = useCategories();
  const {
    categories,
    selectedCategory,
    currentCategories,
    editingCategory,
    editForm,
    newCategory,
    isLoading,
  } = states;

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader className="animate-spin text-[#8F689A]" size={32} />
      </div>
    );
  }

  return (
    <main className="flex min-h-full flex-col bg-[#F1F1F1]">
      <div className="flex min-h-full flex-1 flex-col px-10 pb-20 pt-6">
        <header className="mb-7">
          <h1 className="text-2xl font-bold">Categories</h1>
        </header>

        <div className="flex gap-5">
          <section className="w-2/3">
            <div className="flex gap-2">
              {categories.map((category) => (
                <button
                  type="button"
                  key={category.id}
                  onClick={() => handlers.handleCategoryChange(category)}
                  className={`rounded-tl-[4px] rounded-tr-[4px] px-3 py-1 text-sm font-medium ${
                    selectedCategory?.id === category.id
                      ? 'bg-white text-[#8F689A]'
                      : 'bg-[#DEDEDE] text-white'
                  }`}
                >
                  {category.category}
                </button>
              ))}
            </div>

            <div className="rounded-[4px] rounded-tl-none bg-white shadow-sm">
              <div className="custom-scrollbar h-screen space-y-2 overflow-y-scroll px-3 py-4">
                {currentCategories.map((categoryData) => (
                  <div
                    key={categoryData.id}
                    className="flex items-center justify-start gap-4 rounded"
                  >
                    <div className="flex gap-4">
                      <input
                        type="text"
                        value={
                          editingCategory === categoryData.id
                            ? editForm.categoryName
                            : categoryData.category
                        }
                        onChange={(e) =>
                          editingCategory === categoryData.id &&
                          handlers.handleEditFormChange(
                            'categoryName',
                            e.target.value,
                          )
                        }
                        className="w-52 rounded-[4px] border border-[#CECECE] px-2 py-1 text-sm outline-none"
                        readOnly={editingCategory !== categoryData.id}
                      />
                    </div>
                    <div className="flex gap-2">
                      {editingCategory === categoryData.id ? (
                        <button
                          type="button"
                          onClick={() =>
                            handlers.handleSaveEdit(categoryData.id)
                          }
                          className="boder-[#F6F6F6] rounded-[4px] border p-1 text-[#888888] hover:bg-[#8F689A] hover:text-white"
                        >
                          <Check size={12} />
                        </button>
                      ) : (
                        <button
                          type="button"
                          onClick={() =>
                            handlers.handleEditClick({
                              categoryId: categoryData.id,
                              categoryName: categoryData.category,
                            })
                          }
                          className="boder-[#F6F6F6] rounded-[4px] border p-1 text-[#888888]"
                        >
                          <Edit2 size={12} />
                        </button>
                      )}
                      <button
                        type="button"
                        onClick={() => handlers.handleDelete(categoryData.id)}
                        className="boder-[#F6F6F6] rounded-[4px] border p-1 text-[#888888]"
                      >
                        <X size={12} />
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="w-1/3 pt-[1.625rem]">
            <div className="rounded-[4px] border border-[#EAEAEA] bg-white p-6">
              <div className="mb-4 flex items-center justify-between">
                <h2 className="font-medium">Add Category</h2>
                <button
                  type="button"
                  onClick={handlers.handleCreateCategory}
                  className="rounded-[4px] bg-[#8F689A] px-3 py-1 text-sm text-white shadow-sm hover:bg-opacity-90"
                >
                  Save
                </button>
              </div>

              <div className="space-y-4">
                <div>
                  <select
                    value={newCategory.parentCategoryId}
                    onChange={(e) =>
                      handlers.handleNewCategoryChange(
                        'parentCategoryId',
                        e.target.value,
                      )
                    }
                    className="w-1/2 rounded-[4px] border border-[#E2E2E2] bg-[#DEDEDE] p-2 text-xs outline-none"
                  >
                    {categories.map((category) => (
                      <option key={category.id} value={category.id}>
                        {category.category}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <input
                    type="text"
                    placeholder="Category Content"
                    value={newCategory.childCategoryName}
                    onChange={(e) =>
                      handlers.handleNewCategoryChange(
                        'childCategoryName',
                        e.target.value,
                      )
                    }
                    className="w-full rounded-[4px] border border-[#CECECE] p-2 text-sm outline-none"
                  />
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </main>
  );
};

export default CategoriesListPage;
